import styled from 'styled-components';

export const RevenueChartsContainer = styled.div`
  width: 100%;
  height: fit-content;

  display: flex;
  flex-wrap: wrap;
  gap: 1.875rem;

  @media (min-width: 1100px) {
    flex-wrap: nowrap;
  }
`;
